import { orderBy } from "lodash";

import { MODULE } from "./teams.actionTypes";

export const isSaving = (state) => state.getIn([MODULE, "isSaving"]);

export const isFetching = (state) => state.getIn([MODULE, "isFetching"]);

export const getLists = (state) => orderBy(state.getIn([MODULE, "lists"]), ["firstName"], ["asc"]);

export const getActiveTeamMember = (state) => state.getIn([MODULE, "activeTeamMember"]);

export const isFetchingInviteLink = (state) => state.getIn([MODULE, "isFetchingInviteLink"]);

export const getInviteLink = (state) => state.getIn([MODULE, "inviteLink"]);

export const isSendingInvite = (state) => state.getIn([MODULE, "isSendingInvite"]);

export const getEmployeeList = (state) => orderBy(state.getIn([MODULE, "employeeList"]));
